var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 13.1243C3.17771 13.1243 2.91667 13.4055 2.91667 13.7493C2.91667 14.093 3.17771 14.3742 3.5 14.3742H10.5C10.8208 14.3742 11.0833 14.093 11.0833 13.7493C11.0833 13.4055 10.8208 13.1243 10.5 13.1243H3.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91935 10.8L2.72266 7.20001H3.7137L4.3161 9.22681L4.92326 7.20001H5.91635L4.71505 10.8H3.91935Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.77929 7.20001L5.51815 10.8H6.48401L6.72445 10.0506H7.58583L7.82683 10.8H8.79497L7.52923 7.20001H6.77929ZM7.31657 9.2132L7.15465 8.70967L6.9931 9.2132H7.31657Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.265 8.03957V10.8H9.35568V8.03957H8.42901V7.20001H11.1999V8.03957H10.265Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54635 0.183076L2.89005 1.95692L0.967604 0.15464C0.795156 -0.00683598 0.550885 -0.0454667 0.342271 0.0558559C0.133875 0.157179 0 0.379744 0 0.624966V19.3739C0 19.62 0.133839 19.8075 0.342271 19.9442C0.550885 20.0458 0.795156 20.0067 0.967604 19.8427L2.89005 18.042L4.54635 19.8153C4.7724 20.0614 5.14427 20.0614 5.37031 19.8153L7 18.0693L8.62969 19.8153C8.85573 20.0614 9.2276 20.0614 9.45364 19.8153L11.1089 18.042L13.0339 19.8427C13.2052 20.0067 13.4495 20.0458 13.6573 19.9442C13.8651 19.8075 14 19.62 14 19.3739V0.624966C14 0.379744 13.8651 0.157179 13.6573 0.0558559C13.4495 -0.0454667 13.2052 -0.00683598 13.0339 0.15464L11.1089 1.95692L9.45364 0.183076C9.2276 -0.0610128 8.85573 -0.0610128 8.62969 0.183076L7 1.92841L5.37031 0.183076C5.14427 -0.0610128 4.7724 -0.0610128 4.54635 0.183076ZM3.32901 16.7452C3.11208 16.5108 2.76354 16.4991 2.5324 16.6827L1.16667 17.9951V2.00223L2.5324 3.28263C2.76354 3.49942 3.11208 3.48692 3.32901 3.25412L4.95833 1.5089L6.58802 3.25412C6.81406 3.49825 7.18594 3.49825 7.41198 3.25412L9.04167 1.5089L10.6714 3.25412C10.8865 3.48692 11.2365 3.49942 11.4661 3.28263L12.8333 2.00223V17.9951L11.4661 16.6827C11.2365 16.4991 10.8865 16.5108 10.6714 16.7452L9.04167 18.4912L7.41198 16.7452C7.18594 16.4991 6.81406 16.4991 6.58802 16.7452L4.95833 18.4912L3.32901 16.7452Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVat);
export default __webpack_public_path__ + "static/media/iconVAT.1a779a15d961dd8d22275afe23d23673.svg";
export { ForwardRef as ReactComponent };